<template>
  <div class="sn-f-col-b-s area">
    <div class="sn-f-s-0 sn-f-b-e" style="width: 100%;">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_GHYY),
      }]"></sn-breadcrumb>
      <div class="sn-f-e-c sn-search">
        <input placeholder="搜索医生、科室、疾病" v-model="dynamic" @keyup.enter="navigateUrl('/appointment/search', '', {
          dynamic: dynamic ? encodeURIComponent(dynamic) : ''
        });"/>
        <div class="sn-f-c-c interaction" @click="navigateUrl('/appointment/search', '', {
          dynamic: dynamic ? encodeURIComponent(dynamic) : ''
        });">查询</div>
      </div>
    </div>
    <div class="sn-f-1 area-region">
      <div class="area-blank" :key="area.areaId" v-for="area in areaList">
        <div class="sn-f-b-e sn-title">
          <div class="sn-f-c-c title-caption">{{ area.areaName }}</div>
        </div>
        <div class="sn-f-b-s area-info">
          <div class="area-header">
            <img :src="area.photo">
            <div class="area-title">{{ area.areaName }}</div>
            <div class="area-address">{{ area.address }}</div>
          </div>
          <div class="sn-f-1 sn-f-s-c sn-f-wrap">
            <div class="sn-f-col-c-c sn-pointer area-business" :key="business.type" v-for="business in area.business" @click="goBusiness(area, business);">
              <div class="label"></div>
              <div class="sn-fs-22">{{ business.title }}</div>
              <div class="sub" v-if="business.caption" v-html="business.caption"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import { businessConfig } from '@/common/utils/function-config.js';
import self from '@/common/utils/global-config';
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  mixins: [HomepageMixin],
  data() {
    return {
      dynamic: '',
      areaList: self.$sn.utils.getHospitalAreaInformation()
    };
  },
  created: function() {
    this.formatFunctionConfig();
  },
  methods: {
    formatFunctionConfig() {
      const func = [];
      const business = businessConfig();
      if (!this.$sn.validate.empty(this.$sn.getConfig('areaOrdinaryFunctionType'))) {
        this.$sn.getConfig('areaOrdinaryFunctionType').forEach(type => {
          const match = this.$sn.format.clone(business).find(result => result.type === type);
          if (!this.$sn.validate.empty(match)) {
            func.push(match);
          }
        });
      }
      this.areaList.forEach(area => {
        this.$set(area, 'business', this.$sn.format.clone(func));
        if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
          if (area.areaId === '2') {
            const match = this.$sn.format.clone(business).find(result => result.type === this.perpetual.BASIC_BUSINESS_OFFLINE_GJTXMZ);
            if (!this.$sn.validate.empty(match)) {
              area.business.push(match);
            }
          }
        }
        area.business = this.$sn.format.digitalSort(area.business);
      });
    },
    goBusiness(area, business) {
      this.$sn.utils.setHospitalSessionStorage('AppointmentArea', area);
      if (business.url) {
        this.navigateUrl(business.url, business, business.params);
        return false;
      }
      this.$sn.utils.setHospitalSessionStorage('AppointmentType', business.type);
      this.navigateUrl('/appointment/depart');
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.area {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;

    .area-blank {
      overflow: hidden;
      width: 100%;
      padding: 0 20px;
      margin-bottom: 20px;

      &:first-child {
        margin-top: 20px;
      }

      .area-info {
        overflow: hidden;
        width: 100%;
        padding: 20px 20px 0;

        .area-header {
          overflow: hidden;
          width: 240px;
          background-color: $background2;
          border: 1px solid $border1;
          border-radius: 8px;
          padding: 20px 20px 40px;
          margin-right: 80px;

          img {
            width: 100%;
            height: auto;
          }

          .area-title {
            @include fs(24);

            overflow: hidden;
            width: 100%;
            color: $main;
            text-align: center;
            border-bottom: 1px solid $border1;
            padding: 10px 0;
          }

          .area-address {
            @include fs(16);

            overflow: hidden;
            width: 100%;
            color: $text3;
            text-align: center;
            padding-top: 10px;
          }
        }

        .area-business {
          width: 280px;
          height: 100px;
          background-color: $main1;
          color: $white;
          padding: 10px;
          margin: 20px 160px 20px 0;
          position: relative;

          &:nth-child(2n+2) {
            margin-right: 0;
          }

          &::before,
          &::after {
            content: '';
            width: 280px;
            height: 1px;
            background-color: $white;
            position: absolute;
            right: 0;
            left: 0;
          }

          &::before {
            top: 3px;
          }

          &::after {
            bottom: 3px;
          }

          .label {
            width: 10px;
            height: 10px;
            background-color: $white;
            border-radius: 50%;
            box-shadow: 0 0 10px $black;
            position: absolute;
            top: 9px;
            left: 6px;
          }

          .sub {
            @include fs(14);

            margin-top: 4px;
          }
        }
      }
    }
  }
}
</style>
